<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog"
      content-class="campaignGiftDialog"
      persistent max-width="730">      
      <v-card
        style="max-height: 100%;"
      >
        <v-card-title class="headline">
          <h1>{{ isTicket ? "Novo Ticket / Cota" : "Novo Brinde" }}</h1>
          <v-btn class="close-modal" @click="closeModal">
            <i class="fal fa-times"></i>
          </v-btn>
        </v-card-title>
        <v-card-text style="flex: 0;">
          <v-flex flex-column>
            <v-layout pa-3>
              <v-flex xs5 pr-3>
                <div class="upload-image" id="previewGiftImage" ref="previewGiftImage">
                  <label for="upload-activity">
                    <i class="fas fa-camera-alt"></i>
                  </label>
                  <label
                    for="upload-activity"
                    class="do-upload"
                    v-show="campaignGift.file.path == ''"
                  >
                    <i class="fal fa-cloud-upload"></i>Faça Upload
                  </label>
                  <input
                    type="file"
                    id="upload-activity"
                    accept="image/*"
                    @change="giftFileChanged"
                    ref="upload_activity"
                  />
                </div>
              </v-flex>
              <!-- TICKET -->
              <template v-if="isTicket">
                <v-flex xs7>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <InputText
                        ref="nameInput"
                        type="text"
                        place-holder="Dê um nome para este brinde"
                        textLabel="Nome do brinde"
                        v-model="campaignGift.name"
                        invalidInputMessage="Preencha o nome do brinde"
                        labelCharLimit="50"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <v-checkbox
                        v-model="campaignGift.openValue"
                        :label="`Brinde de valor aberto`"
                        @change="changeOpenValue"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs12>
                      <v-checkbox
                        v-model="campaignGift.openTickets"
                        :label="`Brinde com tickets ilimitados`"
                        @change="changeOpenTickets"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs6 pr-2 v-if="showValue">
                      <InputMoney
                        ref="fixedValueInput"
                        type="tel"
                        v-model="campaignGift.fixedValue"
                        :precision="2"
                        textLabel="Valor"
                        :infoVisible="false"
                        invalidInputMessage="Preencha o valor"
                      />
                    </v-flex>
                    <v-flex xs6 v-if="showTicketsQtde">
                      <InputText
                        ref="availableTicketsQuantityInput"
                        v-model.number="campaignGift.availableTicketsQuantity"
                        type="tel"
                        place-holder="340"
                        textLabel="Ingressos disponíveis"
                        invalidInputMessage="Preencha a quantidade disponível"
                        mask="#########"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <InputDateRange
                        ref="initialFinalDateInput"
                        textLabel="Data/Período"
                        place-holder="Selecione"
                        v-model="campaignGift.initialFinalDates"
                        :monthsToShow="3"
                        :allowSingleDate="true"
                        invalidInputMessage="Preencha o intervalo de datas"
                      ></InputDateRange>
                    </v-flex>
                    <div class="txtarea-labels input-comp">
                      <label>Observações</label>
                      <InputTextArea
                        ref="descriptionInput"
                        rows="2"
                        v-model="campaignGift.description"
                        place-holder="Escreva sobre esta atividade do projeto"
                        invalidInputMessage="Preencha a descrição da faixa"
                        labelAreaCharLimit="1000"
                      ></InputTextArea>
                    </div>
                    <div class="txtarea-labels input-comp">
                      <label>Regras e Condições</label>
                      <InputTextArea
                        ref="rulesAndConditionsInput"
                        rows="2"
                        v-model="campaignGift.rulesAndConditions"
                        place-holder="Escreva sobre as regras e condições"
                        invalidInputMessage="Preencha as regras e condições"
                      ></InputTextArea>
                    </div>
                    <div class="txtarea-labels input-comp">
                      <label>
                        Url Customizada
                        <br />
                        Exemplo: {{ "*.abraceumacausa.com.br/carrinho?Gift=" + campaignGift.customUrl }}
                      </label>
                      <InputTextArea
                        rows="1"
                        :maxlength="40"
                        v-model="campaignGift.customUrl"
                        place-holder="Valor para a url customizada sem espaços em branco"
                        invalidInputMessage="Valor para a url customizada"
                      ></InputTextArea>
                    </div>
                  </v-layout>
                  <div class="txtarea-labels input-comp"></div>
                </v-flex>
              </template>
              <!-- PRODUTO DE DOAÇÃO -->
              <template v-else>
                <v-flex xs7>
                  <InputText
                    ref="nameInput"
                    v-model="campaignGift.name"
                    type="text"
                    place-holder="Dê um nome para este brinde"
                    textLabel="Nome do brinde"
                    invalidInputMessage="Preencha o nome do brinde"
                    labelCharLimit="50"
                  />
                  <InputMoney
                    ref="initialPriceInput"
                    v-model="campaignGift.initialValue"
                    :precision="2"
                    textLabel="Valor mínimo do brinde"
                    invalidInputMessage="preencha o valor mínimo do brinde"
                  />
                  <InputMoney
                    ref="finalPriceInput"
                    v-model="campaignGift.finalValue"
                    textLabel="Valor máximo do brinde"
                    invalidInputMessage="preencha o valor máximo do brinde"
                    :precision="2"
                  />
                  <v-layout>
                    <v-flex xs12 pr-2>
                      <InputText
                        ref="suggestionValueInput"
                        v-model="campaignGift.suggestionValue"
                        type="text"
                        place-holder="Dê um valor para este brinde"
                        textLabel="Valor sugerido (Coloque R$ antes de valores) - Opcional"
                        helpLabel="Ex: de R$20 a R$40"
                        :required="false"
                      />
                    </v-flex>
                  </v-layout>
                  <div class="txtarea-labels input-comp">
                    <label>Descrição</label>
                    <InputTextArea
                      ref="descriptionInput"
                      v-model="campaignGift.description"
                      rows="2"
                      invalidInputMessage="Preencha a descrição da faixa"
                      labelAreaCharLimit="250"
                    ></InputTextArea>
                  </div>
                  <div class="txtarea-labels input-comp">
                    <label>
                      Url Customizada
                      <br />
                      Exemplo: {{ "*.abraceumacausa.com.br/carrinho?Gift=" + campaignGift.customUrl }}
                    </label>
                    <InputTextArea
                      rows="1"
                      :maxlength="40"
                      v-model="campaignGift.customUrl"
                      place-holder="Valor para a url customizada sem espaços em branco"
                      invalidInputMessage="Valor para a url customizada"
                    ></InputTextArea>
                  </div>
                </v-flex>
              </template>
            </v-layout>
            <v-layout pa-3 d-flex flex-column>
              <v-layout xs12 md12 align-center>
                <v-flex xs1>
                  <v-switch label v-model="campaignGift.showQuestions" class="ma-0"></v-switch>
                </v-flex>
                <h3 class="title-category">Especificações</h3>
              </v-layout>
              <transition name="slide-fade" mode="out-in">
                <v-layout d-flex flex-column v-if="campaignGift.showQuestions">
                  <div
                    v-for="(campaignGiftQuestion, index) in campaignGift.campaignGiftQuestionList.filter((x) => x.active == true)"
                    :key="campaignGiftQuestion.Order"
                  >
                    <v-layout xs12 pr-2 align-center>
                      <!-- <v-flex xs6> -->
                      <v-flex xs11>
                        <InputText
                          ref="questionInput"
                          v-model="campaignGiftQuestion.question"
                          type="text"
                          place-holder="Etiqueta da especificação"
                          textLabel="Etiqueta"
                          :required="false"
                        />
                      </v-flex>
                      <!-- <v-flex xs5 pl-2>
                        <InputSelect
                          :items="answerType"
                          textLabel="Tipo de resposta"
                          valueAttribute="id"
                          textAttribute="name"
                        ></InputSelect>
                      </v-flex>-->
                      <v-flex xs1 pt-4 class="d-flex flex-row">
                        <a
                          @click="addQuestion()"
                          v-if="index == campaignGift.campaignGiftQuestionList.length - 1"
                        >
                          <Icon
                            name="fal fa-plus-circle justify-end d-flex"
                            size="24"
                            class="ml-2"
                            colorFont="#C3C6D5"
                          />
                        </a>
                        <a @click="removeQuestion(index)">
                          <Icon
                            name="fal fa-trash justify-end d-flex"
                            size="24"
                            class="ml-2"
                            colorFont="#C3C6D5"
                          />
                        </a>
                      </v-flex>
                    </v-layout>
                    <v-layout xs12 md12 align-center>
                      <v-switch
                        label="Alternativas"
                        v-model="campaignGiftQuestion.hasAlternatives"
                        class="ma-0"
                        @change="changeSwitchAlternatives(campaignGiftQuestion)"
                      ></v-switch>
                    </v-layout>
                    <v-layout pr-4 flex-wrap v-if="campaignGiftQuestion.hasAlternatives">
                      <v-layout
                        v-for="(alternative, index) in campaignGiftQuestion.campaignGiftQuestionAlternatives"
                        :key="alternative.id"
                        xs12
                        md6
                        lg4
                        pr-2
                        align-center
                        class="flex"
                      >
                        <v-flex xs10>
                          <InputText
                            ref="alternativeInput"
                            v-model="alternative.description"
                            type="text"
                            place-holder="Etiqueta da especificação"
                            textLabel="Etiqueta"
                            :required="false"
                          />
                        </v-flex>
                        <v-flex xs2 pt-4 class="d-flex flex-row">
                          <a
                            v-if="index == campaignGiftQuestion.campaignGiftQuestionAlternatives.length - 1"
                            @click="addAlternative(campaignGiftQuestion)"
                          >
                            <Icon
                              name="fal fa-plus-circle justify-center d-flex"
                              size="20"
                              colorFont="#C3C6D5"
                            />
                          </a>
                          <a @click="removeAlternative(index, campaignGiftQuestion)">
                            <Icon
                              name="fal fa-trash justify-center d-flex"
                              size="20"
                              colorFont="#C3C6D5"
                            />
                          </a>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </div>
                  <!-- <v-layout xs12 pr-2 align-center>
                    <v-flex xs2>
                      <InputText
                        type="text"
                        place-holder="Ex: P"
                        textLabel="Opções"
                        :required="false"
                      />
                    </v-flex>
                    <v-flex xs2>
                      <InputText
                        type="text"
                        :required="false"
                        class="pl-2"
                        style="padding-top: 20px"
                      />
                    </v-flex>
                    <v-flex xs2>
                      <InputText
                        type="text"
                        :required="false"
                        class="pl-2"
                        style="padding-top: 20px"
                      />
                    </v-flex>
                    <v-flex xs2>
                      <InputText
                        type="text"
                        :required="false"
                        class="pl-2"
                        style="padding-top: 20px"
                      />
                    </v-flex>
                    <v-flex xs2>
                      <InputText
                        type="text"
                        :required="false"
                        class="pl-2"
                        style="padding-top: 20px"
                      />
                    </v-flex>
                    <v-flex xs2>
                      <InputText
                        type="text"
                        :required="false"
                        class="pl-2"
                        style="padding-top: 20px"
                      />
                    </v-flex>
                    <v-flex xs2>
                      <InputText
                        type="text"
                        :required="false"
                        class="pl-2"
                        style="padding-top: 20px"
                      />
                    </v-flex>
                  </v-layout>-->
                </v-layout>
              </transition>
            </v-layout>
          </v-flex>
        </v-card-text>
        <v-card-actions class="pa-0">
          <div class="footer-modal-atividades">
            <v-btn
              flat
              round
              color="white"
              class="btn btn-default px-5"
              large
              @click="closeModal"
            >Cancelar</v-btn>
            <v-btn
              flat
              round
              color="white"
              class="btn btn-primary px-5"
              large
              @click="isValid"
            >Salvar</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script type="plain/text">
import CampaignGift from "@/scripts/models/CampaignGift.model";
import CampaignGiftQuestion from "@/scripts/models/campaignGiftQuestion.model";
import CampaignGiftQuestionAlternatives from "@/scripts/models/campaignGiftQuestionAlternatives.model";
import ValidatableComponent from "@/components/base/ValidatableComponent.vue";
import { GetCurrentOrder } from "@/scripts/helpers/list.helper";
import CampaignService from "@/scripts/services/campaign.service";
import CommonHelper from "@/scripts/helpers/common.helper";
import FileService from "@/scripts/services/file.service.js";

// VUEX
import { mapGetters, mapActions } from "vuex";

export default {
  extends: ValidatableComponent,
  props: ["campaignId", "isTicket", "dialog", "toEdit"],
  data() {
    return {
      CommonHelper: CommonHelper,
      showValue: true,
      showTicketsQtde: true,
      campaignService: new CampaignService(),
      campaignGift: new CampaignGift(),
      fileService: new FileService(),
      campaignGiftList: this.value,
      originalCampaignGift: null,
      validCustomUrl: true,
      answerType: [
        {
          id: 1,
          name: "Checkbox",
        },
        {
          id: 2,
          name: "Radio",
        },
      ],
    };
  },
  watch: {
    "campaignGift.showQuestions": {
      handler: function (after) {
        if (after && this.campaignGift.campaignGiftQuestionList.length == 0) {
          let campaignGiftQuestion = new CampaignGiftQuestion();

          campaignGiftQuestion.campaignGiftQuestionAlternatives.push(new CampaignGiftQuestionAlternatives());

          this.campaignGift.campaignGiftQuestionList.push(campaignGiftQuestion);
        }
      },
      deep: true,
    },
  },
  created() {
    this.onValidationSuccessMethod = this.validationSuccess;
    this.validationMethod = this.validate;
  },
  mounted() {
    if (this.toEdit) this.addToEdit(this.toEdit)
  },
  methods: {
    ...mapActions([
      'refreshCampaignGifts'
    ]),
    changeOpenValue(value) {
      this.showValue = !value;
      if (!value) this.campaignGift.fixedValue = 0;
    },
    changeOpenTickets(value) {
      this.showTicketsQtde = !value;
      if (!value) this.campaignGift.availableTicketsQuantity = 0;
    },
    async listByCampaignId() {
      this.campaignService.listCampaignGiftByCampaignId().then(data => {
        for (let Gift of data) {
          Gift.file = this.getImage(Gift)
        }
        this.$emit("input", data)
      });
    },
    async getImage(item) {
      this.fileService
        .getById(item.fileId).then((file) => {
          item.file = file
        })
    },
    async save() {
      if (this.campaignGift.customUrl != null) {
        if (this.campaignGift.customUrl.indexOf(' ') >= 0) {
          this.CommonHelper.swal("A URL customizada não pode conter espaços em branco");
          this.validCustomUrl = false;
          return;
        }
      }
      this.validCustomUrl = true;
      this.campaignGift.campaignId = this.campaignId;

      this.campaignService.saveCampaignGift(this.campaignGift).then(() => {
        this.refreshCampaignGifts();
      });
    },
    changeStatus(campaignGift, current) {
      campaignGift.campaignId = this.campaignId;
      campaignGift.active = current;
      this.campaignService.saveCampaignGift(this.refreshList, campaignGift);
    },
    remove(campaignGiftId) {
      this.campaignService.deleteCampaign(this.refreshList, campaignGiftId);
    },
    refreshList() {
      this.listByCampaignId();
    },
    changeSwitchAlternatives(campaignGiftQuestion) {
      if (campaignGiftQuestion.hasAlternatives && campaignGiftQuestion.campaignGiftQuestionAlternatives.length == 0) {
        let newAlternative = new CampaignGiftQuestionAlternatives();
        campaignGiftQuestion.campaignGiftQuestionAlternatives.push(newAlternative);
      }
    },
    addAlternative(campaignGiftQuestion) {
      let valid = true;

      for (let i = 0; i < campaignGiftQuestion.campaignGiftQuestionAlternatives.length; i++) {
        if (!campaignGiftQuestion.campaignGiftQuestionAlternatives[i].description) {
          this.$refs.alternativeInput[i].focus();
          valid = false;
        }
      }
      if (valid) {
        let newAlternative = new CampaignGiftQuestionAlternatives();
        campaignGiftQuestion.campaignGiftQuestionAlternatives.push(newAlternative);
      }
    },
    removeAlternative(index, campaignGiftQuestion) {
      campaignGiftQuestion.campaignGiftQuestionAlternatives.splice(index, 1);
    },
    addQuestion() {
      let valid = true;

      for (let i = 0; i < this.campaignGift.campaignGiftQuestionList.length; i++) {
        if (!this.campaignGift.campaignGiftQuestionList[i].question) {
          this.$refs.questionInput[i].focus();
          valid = false;
        }
      }

      if (valid) {
        let newQuestion = new CampaignGiftQuestion();
        newQuestion.Order = GetCurrentOrder(this.campaignGift.campaignGiftQuestionList);
        newQuestion.campaignGiftQuestionAlternatives.push(new CampaignGiftQuestionAlternatives());
        this.campaignGift.campaignGiftQuestionList.push(newQuestion);
      }
    },
    removeQuestion(index) {
      this.campaignGift.campaignGiftQuestionList.splice(index, 1);
    },
    validate(performMethods) {      
      if (this.campaignGift.file == null || this.campaignGift.file.path == "") {
        this.$store.commit("SET_SNACKBAR_MESSAGE", "Escolha uma imagem para o produto");
        return false;
      }

      let valid = this.validateComponents(performMethods);
      if (!valid) return false;
      if (this.campaignGift.showQuestions) {
        for (let i = 0; i < this.campaignGift.campaignGiftQuestionList.length; i++) {
          if (!this.campaignGift.campaignGiftQuestionList[i].question) {
            if (this.campaignGift.campaignGiftQuestionList.length == 1) {
              this.$refs.questionInput[i].focus();
              valid = false;
            } else if (i == this.campaignGift.campaignGiftQuestionList.length - 1) {
              this.removeQuestion(i);
              valid = true;
            } else {
              this.$refs.questionInput[i].focus();
              valid = false;
            }
          }
        }
      }
      return valid;
    },
    validationSuccess() {
      if (this.campaignGift.initialValue)
      this.campaignGift.initialValue = (this.campaignGift.initialValue).toFixed(2)

      if (this.campaignGift.finalValue)
      this.campaignGift.finalValue = (this.campaignGift.finalValue).toFixed(2)

      this.save();
      if (this.validCustomUrl) {
        this.closeModal();
      }
    },
    closeModal() {
      this.$emit('close')
      this.copy(new CampaignGift(), this.campaignGift);
      this.$refs.previewGiftImage.style.backgroundImage = "";
    },
    giftFileChanged(event) {
      console.log(event)
      var file = event.target.files[0];
      if (file) {
        let reader = new FileReader();
        this.campaignGift.file.name = file.name;
        reader.onload = function () {
          this.$refs.previewGiftImage.style.backgroundImage = "url(" + reader.result + ")";
          this.campaignGift.file.path = reader.result;
        }.bind(this);
        reader.readAsDataURL(file);
      }
    },
    addToEdit(item) {      
      console.log(item)
      this.originalCampaignGift = item;
      this.copy(this.originalCampaignGift, this.campaignGift);
      this.showValue = !this.campaignGift.openValue;
      this.showTicketsQtde = !this.campaignGift.openTickets;
      this.$refs.previewGiftImage.style.backgroundImage = "url(" + item.file.path + ")";
      this.$refs.nameInput.showValidationMessage = false;
      this.$refs.descriptionInput.showValidationMessage = false;
      if (this.isTicket) {
        this.$refs.fixedValueInput.showValidationMessage = false;
        this.$refs.availableTicketsQuantityInput.showValidationMessage = false;
        this.$refs.initialFinalDateInput.showValidationMessage = false;
        this.$refs.rulesAndConditionsInput.showValidationMessage = false;
        this.$refs.customUrlInput.showValidationMessage = false;
      } else {
        this.$refs.suggestionValueInput.showValidationMessage = false;
      }
    },
    copy(from, to) {
      to.Order = from.Order;
      to.id = from.id;
      to.name = from.name;
      to.suggestionValue = from.suggestionValue;
      to.initialValue = from.initialValue;
      to.finalValue = from.finalValue;
      to.description = from.description;
      to.showQuestions = from.showQuestions;
      to.campaignGiftQuestionList = [];
      to.availableTicketsQuantity = from.availableTicketsQuantity;
      to.rulesAndConditions = from.rulesAndConditions;
      to.fixedValue = from.fixedValue;
      to.openValue = from.openValue;
      to.openTickets = from.openTickets;
      to.customUrl = from.customUrl;
      to.initialFinalDates = [];
      if (from.initialFinalDates.length == 2) {
        to.initialDate = from.initialFinalDates[0];
        to.initialFinalDates[0] = from.initialFinalDates[0];
        if (from.initialFinalDates[1]) {
          to.finalDate = from.initialFinalDates[1];
          to.initialFinalDates[1] = from.initialFinalDates[1];
        } else {
          to.finalDate = null;
          to.initialFinalDates[1] = null;
        }
      } else {
        to.initialDate = from.initialFinalDates[0];
        to.initialFinalDates[0] = from.initialFinalDates[0];
      }
      if (from.campaignGiftQuestionList)
        for (let i = 0; i < from.campaignGiftQuestionList.length; i++) {
          let question = new CampaignGiftQuestion();
          this.copyQuestion(from.campaignGiftQuestionList[i], question);
          to.campaignGiftQuestionList.push(question);
        }
      to.file.id = from.file.id;
      to.file.userId = from.file.userId;
      to.file.name = from.file.name;
      to.file.path = from.file.path;
      to.file.size = from.file.size;
      to.file.extension = from.file.extension;
      to.file.origin = from.file.origin;
    },
    copyQuestion(from, to) {
      to.Order = from.Order;
      to.id = from.id;
      to.campaignGiftId = from.campaignGiftId;
      to.question = from.question;
      to.hasAlternatives = from.hasAlternatives;
      to.active = from.active;
      from.campaignGiftQuestionAlternatives.forEach((fromAlternative) => {
        let alternative = new CampaignGiftQuestionAlternatives();
        this.copyAlternative(fromAlternative, alternative);
        to.campaignGiftQuestionAlternatives.push(alternative);
      });
    },
    copyAlternative(from, to) {
      to.id = from.id;
      to.description = from.description;
    },
  },
};
</script>
